/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 17:33:13
 * @Explain: 数据报表
 */
import http from '../http';
import httpv2 from '../http-v2';
// type
import type {
  ConvPerformanceReqType,
  ConvPerformanceResType,
  getClickListReqType,
  resCreatedExportReqType,
  resCreatedUndeliveredExportReqType,
} from '@/api/activityReport/data.d';
import type { AxiosResponse } from 'axios';
import type { HttpResponse } from '../data.d';

const MODEL = '/campaignReport';
const NEW_MODEL = '/campaign_report';
const MODEL_TEST = '/campaign_experiment_report';
const MODEL_AB = '/campaign_experiment';
const MODEL_AB_REPORT = '/exp_report';

export default {
  /** 活动报表 - 获取活动列表 */
  getActivityReportList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 活动报表 - 获取活动列表 */
  getActivityReportV2List(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 获取数据分布 */
  getDeliverability(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/data-distribution`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 数据折线图 */
  getLineChart(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/line-chart`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 打开top10 */
  getRanking(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/ranking`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** Benchmarks */
  getDataComparison(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/data-comparison`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 活动报表 - 获取基准对比模块选择的对比活动信息 */
  getCompareActivityReportV2(data: Record<any, any>) {
    return httpv2.post(`${NEW_MODEL}/get_campaign_stats`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 查询游戏指标 */
  getGameIsAccess(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/game-is-access`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 游戏内数据 */
  getGameMetric(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/game-metric`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 游戏内数据排行 */
  getGameRanking(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/game-ranking`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 查询游戏指标 */
  getGameData(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/game-data`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 游戏内指标绑定 */
  bindActivityType(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/bind-activity-type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 获取对应活动周期 */
  getCycleList(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/task-cycle`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 活动点击数量 */
  getClickData(data: Record<any, any>) {
    return httpv2.post(`${MODEL}/click-data`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 活动点击详情 */
  getClickDetail(data: Record<any, any>) {
    return http.post(`${MODEL}/click-detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 点击链接列表 */
  getLinkList(data: Record<any, any>) {
    return http.post(`${MODEL}/link-list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 模板语言列表 */
  templateLang(data: Record<any, any>) {
    return http.post(`${MODEL}/template-lang`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** label更新 */
  onSaveLabel(data: Record<any, any>) {
    return http.post(`${MODEL}/save-label`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 送达能力数据 */
  getOverviewTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/overview`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 邮件参与 折线图数据 */
  getLineChartTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/data_line_chart`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 邮件参与 Table打开top10 */
  getRankingTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/data_table`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 基准对比 - 对比柱形图 */
  getDataComparisonTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/benchmark`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 查询游戏动态指标 */
  getGameIsAccessTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/has_game_metric`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 转化指标变化趋势折线数据 */
  getGameMetricTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/get_game_metric`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 转化指标 国家和语种的数据分布 */
  getGameRankingTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/get_game_metric_ranking`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** A/B test - 活动更换动态指标 */
  bindActivityTypeTest(data: Record<any, any>) {
    return httpv2.post(`${MODEL_TEST}/update_campaign_type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 周期活动 - 获取记录的全部周期说明弹层开启状态 */
  getAllCycleInstructions(data: Record<any, any>) {
    return http.post(`${NEW_MODEL}/cycle_view_status`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 获取试验项变量设置信息 */
  getExperimentDetail(data: Record<any, any>) {
    return http.post(`${MODEL_AB}/get_experiment_detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 基本内容 */
  getAbReportBasicMsg(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/basic_msg`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 模板内容 */
  getAbReportTemplateContent(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/template_content`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 语言地区 */
  getAbReportLocale(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/task_locale`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 折现图 */
  getAbReportLineCompareInfo(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/line_chart_comparison`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 自定义对比柱状图 */
  getAbReportCustomCompareInfo(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/custom_compare`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 获胜组语言详情 */
  getAbReportWinnerLangDetails(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/winning_language_details`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 选择获胜组 */
  selectAbReportWinner(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/select_winner`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 选择获胜组 详情*/
  selectAbReportWinnerGroupInfo(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/winning_group_popup_info`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** abTest活动 - 选择获胜组group  detailtable */
  selectAbReportGroup(data: Record<any, any>) {
    return http.post(`${MODEL_AB_REPORT}/exp_group_detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 报表 - 活动链接导出次数 列表 **/
  getReportLinksClickedList(data: getClickListReqType) {
    return http.post(`${NEW_MODEL}/click_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 创建 导出请求 **/
  resCreatedExport(data: resCreatedExportReqType) {
    return http.post(`${NEW_MODEL}/export_click_flow`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 未送达数据导出
  resCreatedUndeliveredExport(data: resCreatedUndeliveredExportReqType) {
    return http.post(`${NEW_MODEL}/create_non_delivery_export_history`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 活动报表 - 导出活动报表数据
  resCreatedCampaignExport(data: Record<any, any>) {
    return http.post(`${NEW_MODEL}/export`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 活动转化 - 查看活动转化指标接口
  getConvPerformance(
    data: ConvPerformanceReqType,
  ): Promise<AxiosResponse<HttpResponse<ConvPerformanceResType>>> {
    return http.post<HttpResponse<ConvPerformanceResType>>(
      `${NEW_MODEL}/conv_performance`,
      data,
      {
        params: { switchReqToUnderline: true },
      },
    );
  },
};
